import React from 'react'
import DropdownStyle from './DropdownStyle'

const MobileDropdown = ({
  scrollToSection,
  about,
  partners,
  services,
  contact,
  scrolled,
  setIsMobileMenuOpen,
  isMobileOpen,
}) => {
  const handleClick = (section) => {
    scrollToSection(section)
    setIsMobileMenuOpen(!isMobileOpen)
  }

  return (
    <DropdownStyle scrolled={scrolled}>
      <p onClick={() => handleClick(about)}>About</p>
      <p onClick={() => handleClick(services)}>Services</p>
      <p onClick={() => handleClick(partners)}>Games</p>
      <p onClick={() => handleClick(contact)}>Contact</p>
    </DropdownStyle>
  )
}

export default MobileDropdown
